'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _quarkLog = require('quark-log');

var logger = new _quarkLog.Logger();
logger.plugin('namespace', _quarkLog.plugins.namespace, { name: 'quark-raf' });

exports.default = logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-raf/lib/logger.js
// module id = 243
// module chunks = 1